import NaptimeResource from './NaptimeResource';
import OnDemandDiscussionPromptQuestionsV1 from './onDemandDiscussionPromptQuestions.v1';

class OnDemandDiscussionPrompts extends NaptimeResource {
  static RESOURCE_NAME = 'onDemandDiscussionPrompts.v1';

  static DEFAULT_INCLUDES = ['question'];

  static DEFAULT_FIELDS = [
    'promptType',
    `${OnDemandDiscussionPromptQuestionsV1.RESOURCE_NAME}(${OnDemandDiscussionPromptQuestionsV1.DEFAULT_FIELDS.join(
      ','
    )})`,
  ];
}

export default OnDemandDiscussionPrompts;
